<script setup lang="ts">
import { onMounted } from "vue";
import { useApplicationAlertsStore } from "@/stores/ApplicationAlerts";
import routeManager from "@/router/route-manager";

const alertsStore = useApplicationAlertsStore();

onMounted(() => {
  alertsStore.fetchAlerts();
});
</script>

<template>
  <div v-if="alertsStore.issueAlert" class="bg-yellow-500 text-black p-1 text-center">
    <router-link :to="routeManager.appStatusPath()" class="flex items-center justify-center text-black">
      <i class="pi pi-exclamation-triangle mr-2"></i>
      <p>{{ alertsStore.issueAlert.description }}</p>
    </router-link>
  </div>
</template>